module.exports = __webpack_public_path__ + "static/media/root.3ad96c4b.svg";